export const QUOTE_STATUSES = {
	draft: 'draft',
	pending: 'pending',
	expired: 'expired',
	approved: 'awarded',
	disputed: 'declined',
};

export const QUOTE_STATUS_DISPLAY_NAMES = {
	[QUOTE_STATUSES.draft]: 'Drafted',
	[QUOTE_STATUSES.pending]: 'Pending',
	[QUOTE_STATUSES.expired]: 'Expired',
	[QUOTE_STATUSES.disputed]: 'Declined',
	[QUOTE_STATUSES.approved]: 'Approved',
};
